import UserWidget from "@/components/home/dashboard/widgets/UserWidgetClass";
import projectVariables from "@/assets/css/element-variables.scss";

export const WidgetViewMixin = {
  mixins: [],
  props: {
    editMode: { type: Boolean, default: false },
    widget: {type: Object},
    settings: {type: Object},
    data: {type: Object}
  },
  watch: {},
  mounted() {
  },
  data(){
    return {
      loadingWidgetResult: false,
      widgetResult: null,
      projectVariables
    }
  },

  methods: {
    eventWidgetResized(){},

    loadWidgetResult(additionalParams={}){
      this.loadingWidgetResult = true;
      return this.$api.homeDashboard.getWidgetResult({
        id: this.widget.id,
        ...additionalParams,
      })
        .then((data) => {
          this.widgetResult = data.result;
        })
        .finally(()=>{
          this.loadingWidgetResult = false;
        })
    }
  }
}